import React from "react";
import SearchBar from "../components/Service/SearchBar"
import VirtualAgent from "../components/Service/VirtualAgent"
import Slide from "../components/Service/Slide"
import Tamplate from "../components/Service/Tamplate"
import Bottom from "../components/Service/Bottom"





const Service = () => {
  return <div>
    <SearchBar/>
    <VirtualAgent/>
    <Slide/>
     <Tamplate/>
     <Bottom/>
  </div>;
};

export default Service;
